"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _js = _interopRequireDefault(require("./PEP-hearing-instrument-list/js"));

var _js2 = _interopRequireDefault(require("./PEP-product-detail/js"));

var _js3 = _interopRequireDefault(require("./PEP-related-products/js"));

var _utils = require("../configuration/utils");

var _creators = require("../redux/creators");

var _constans = require("../configuration/constans");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var App = function App(_ref) {
  var pepDictionary = _ref.pepDictionary;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      errorCounter = _useState2[0],
      setErrorCounter = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSettingsLoading = _useState4[0],
      setIsSettingsLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      productDetails = _useState6[0],
      setProductDetailsData = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      productList = _useState8[0],
      setProductListData = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      relatedProducts = _useState10[0],
      setRelatedProducts = _useState10[1];

  var _useState11 = (0, _react.useState)(''),
      _useState12 = _slicedToArray(_useState11, 2),
      filtersParams = _useState12[0],
      setFiltersParams = _useState12[1];

  var isMobile = (0, _reactRedux.useSelector)(function (state) {
    return state.isMobile;
  });
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });

  var fetchInit = function fetchInit() {
    var urlParams = new URLSearchParams(window.location.href);
    setIsSettingsLoading(true);
    (0, _utils.getSettings)().then(function (params) {
      var newParams = pepDictionary;
      newParams.settingsParam = _objectSpread({}, params);
      dispatch((0, _creators.setPepDictionary)(newParams));

      if (pepDictionary && pepDictionary.settingsParam.params.isReady) {
        if (document.querySelector(".".concat(_constans.initialState.pepListComponentName))) {
          setProductListData(true);
        }

        if (document.querySelector(".".concat(_constans.initialState.pepAccListComponentName))) {
          setProductListData(true);
        } else if (document.querySelector(".".concat(_constans.initialState.pepDetailsComponentName)) || urlParams.has('productId')) {
          setProductDetailsData(true);
        }
      }

      setIsSettingsLoading(false);
    });
  };

  var resetFetchInitialization = function resetFetchInitialization() {
    if (!isSettingsLoading) {
      setErrorCounter(function (prev) {
        if (prev < 2) {
          fetchInit();
          return prev + 1;
        }
      });
    }
  };

  (0, _react.useEffect)(function () {
    fetchInit();

    if (!dictionary) {
      dispatch((0, _creators.setPepDictionary)(pepDictionary));
    }

    if ((0, _utils.sessionStorageFactory)('checkStorageItem', _constans.initialState.favoriteProductsName)) {
      dispatch((0, _creators.setFavoriteProduct)((0, _utils.sessionStorageFactory)('getItem', _constans.initialState.favoriteProductsName)));
    }

    var resizeListener = function resizeListener() {
      dispatch((0, _creators.setLayoutType)((0, _utils.checkIsMobile)()));
    };

    if (isMobile === null) {
      resizeListener();
    }

    window.addEventListener('resize', resizeListener);
    return function () {
      window.removeEventListener('resize', resizeListener);
    };
  }, [pepDictionary]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isSettingsLoading && (pepDictionary === null || pepDictionary === void 0 ? void 0 : pepDictionary.settingsParam.params.isReady) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: dictionary.instrumentListPath
  }, /*#__PURE__*/_react["default"].createElement(_js["default"], {
    productList: productList,
    isAccessoriesList: false,
    setFiltersParams: setFiltersParams,
    resetFetchInitialization: resetFetchInitialization
  })), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: dictionary.accessoriesListPath
  }, /*#__PURE__*/_react["default"].createElement(_js["default"], {
    productList: productList,
    isAccessoriesList: true,
    setFiltersParams: setFiltersParams,
    resetFetchInitialization: resetFetchInitialization
  })), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_js2["default"], {
    productDetails: productDetails,
    setRelatedProducts: setRelatedProducts,
    filtersParams: filtersParams,
    resetFetchInitialization: resetFetchInitialization
  }), relatedProducts && /*#__PURE__*/_react["default"].createElement(_js3["default"], {
    productList: productList
  }))))));
};

var _default = App;
exports["default"] = _default;